/**
 * Debug mode logger
 * console.error is used instead of console.log because Rollup strips console.log
 * calls in production builds, which would silence debug output on non-localhost sites
 * even when data-debug-mode="true" is set.
 */

/**
 * Log message when debug mode is enabled
 * @param {boolean} debugMode - Whether debug mode is active
 * @param  {...any} args - Arguments to log
 */
export function debugLog(debugMode, ...args) {
  if (debugMode) {
    console.error(...args);
  }
}
